export const ClearableFieldInput = {
  DATE: '0000-01-01',
  NUMBER: -1,
  STRING: '',
};
